import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as emojiFlags from 'emoji-flags';
import { MatTableDataSource } from '@angular/material/table';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { DataTypeComponent } from '../../../data-type-component';

@Component({
  selector: 'app-form-field-availability-summary',
  templateUrl: './availability-summary-form-field.component.html',
  styleUrls: ['./availability-summary-form-field.component.scss'],
  standalone: false,
})
export class AvailabilitySummaryFormFieldComponent extends DataTypeComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() data: AvailabilitySummaryDTO;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() editMode: boolean;

  dataSource: MatTableDataSource<CountryEntry>;

  availableOnly: boolean = false;

  inactiveOnly: boolean = false;

  filterValue: string = '';

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.data?.countries);
  }

  public emoji(d: CountryEntry): any {
    return emojiFlags.countryCode(d.icon).emoji;
  }

  onFilterChange(event: Event) {
    this.dataSource.filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
  }

  onAvailableChange(): void {
    if (this.availableOnly) {
      this.inactiveOnly = false;
      this.dataSource.data = this.data?.countries?.filter((c) => c.available);
    } else {
      this.dataSource.data = this.data?.countries;
    }
  }

  onInactiveChange(): void {
    if (this.inactiveOnly) {
      this.availableOnly = false;
      this.dataSource.data = this.data?.countries?.filter((c) => !c.available);
    } else {
      this.dataSource.data = this.data?.countries;
    }
  }
}

export interface AvailabilitySummaryDTO {
  countries: CountryEntry[];
  links: LinkEntry[];
}

export enum AvailabilitySummaryMode {
  COUNTRY = 'COUNTRY',
  ENTITY = 'ENTITY',
}

export interface CountryEntry {
  icon: string;
  countryName: string;
  available: boolean;
  restrictionReason: string[];
  entityName: string;
  mode: AvailabilitySummaryMode;
}

export class LinkEntry {
  label: string;

  url: string;
}
